(() => {
  if (!customElements.get('fm-product-social-proof')) customElements.define('fm-product-social-proof', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized) return;
      this.dataset.initialized = 'true';
      this.querySelectorAll('[data-fm-random-number]').forEach(node => {
        const a = Number(node.dataset.min), b = Number(node.dataset.max);
        if (Number.isFinite(a) && Number.isFinite(b)) node.textContent = Math.floor(Math.random() * (Math.abs(b-a)+1)) + Math.min(a,b);
      });
    }
  });
  if (!customElements.get('fm-thumbnail-height-sync')) customElements.define('fm-thumbnail-height-sync', class extends HTMLElement {
    connectedCallback() {
      this.root = this.closest('.shopify-section');
      if (!this.root || !window.ResizeObserver) return;
      this.resize = new ResizeObserver(() => this.measure());
      this.bind = () => {
        const slider = this.root.querySelector('media-gallery slider-element');
        if (slider !== this.slider) {
          this.resize.disconnect(); this.slider = slider;
          if (slider) this.resize.observe(slider);
        }
        this.measure();
      };
      this.measure = () => {
        const thumbs = this.root.querySelector('.product__thumbnails--beside');
        const height = this.slider?.getBoundingClientRect().height;
        if (thumbs && height > 0) thumbs.style.setProperty('--fm-gallery-height', height + 'px');
      };
      this.mutations = new MutationObserver(this.bind);
      this.mutations.observe(this.root, {childList:true, subtree:true});
      this.bind();
    }
    disconnectedCallback() { this.resize?.disconnect(); this.mutations?.disconnect(); }
  });
})();
